<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle1"><a id="page_vii"></a><a id="ack"></a>Acknowledgments</h1>
<p class="text">I would like to thank my excellent and kind editor, Caroline Pincus, whose wise advice I treasured. No book is the product of a single person. There is always a team of editors, publicists, cover artists, book designers, and many other people who change the author's raw manuscript into a professionally produced book. I would like to tip my hat to the team at Red Wheel/Weiser. Thank you all for your hard work!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05acknowledgment.vue?3aa40126